/**
 * Hibrit Çalışan Saha Modu Geçiş Talebi Servisi
 *
 * Bekleyen talepleri getirme ve onaylama/reddetme için backend API'leri ile iletişimi sağlar.
 * overtime.service.ts ile aynı desende, singleton pattern.
 */

import apiService from '../api/api.service';
import {
  FieldModeRequestDto,
  FieldModeRequestReviewDTO,
  FieldModeSession,
  FieldModeSessionsQuery,
} from '../../types/fieldModeRequest.types';

class FieldModeRequestService {
  private static instance: FieldModeRequestService;

  private constructor() {}

  public static getInstance(): FieldModeRequestService {
    if (!FieldModeRequestService.instance) {
      FieldModeRequestService.instance = new FieldModeRequestService();
    }
    return FieldModeRequestService.instance;
  }

  /**
   * Bekleyen saha modu geçiş taleplerini getirir (Yönetici için)
   */
  public async getPendingFieldModeRequests(): Promise<FieldModeRequestDto[]> {
    return apiService.get('/field-mode-requests/pending');
  }

  /**
   * Saha modu geçiş talebini onayla veya reddet (Yönetici için)
   */
  public async reviewFieldModeRequest(id: number, data: FieldModeRequestReviewDTO): Promise<FieldModeRequestDto> {
    return apiService.put(`/field-mode-requests/${id}/review`, data);
  }

  /**
   * Saha oturumlarını (sahaya çıkış → ofise dönüş) getirir, en yeni önce.
   * userId verilmezse şirket genelindeki kayıtlar döner.
   */
  public async getFieldModeSessions(query: FieldModeSessionsQuery): Promise<FieldModeSession[]> {
    return apiService.get<FieldModeSession[]>('/field-mode-requests/sessions', {
      params: {
        ...(query.userId ? { userId: query.userId } : {}),
        startDate: query.startDate,
        endDate: query.endDate,
      },
    });
  }
}

export default FieldModeRequestService.getInstance();
